export default __webpack_public_path__ + "static/media/hankaProfilCropped.6738dac8.jpg";